import styled, { keyframes } from 'styled-components';

export const Container = styled.div`
	height: 60px;
	width: 100%;
	background-repeat: no-repeat, repeat;
	background-size: 100% 100%;
	background-position: center;
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

export const PromocodeWrapper = styled.div`
	width: 100%;
	height: 60px;
	display: flex;
	align-items: stretch;
	align-items: center;
	justify-content: space-between;
	padding: 5px 10px;
	background: linear-gradient(243.18deg, #6467f0 0%, #402c86 102.28%);
	border-radius: 5px;
`;

export const TextWrapper = styled.span`
	font-weight: 400;
	font-size: 11px;
	line-height: 12px;
	letter-spacing: -0.41px;
	color: #ffffff;
`;

export const Title = styled.div`
	font-weight: 600;
	font-size: 18px;
	line-height: 24px;
	letter-spacing: -0.578824px;
	color: #89ffac;

	@media (max-width: 340px) {
		font-size: 16px;
	}
`;

export const Promocode = styled.span`
	color: #89ffac;
	text-transform: uppercase;
	padding-left: 3px;
`;

const gradient = keyframes`
  0% { background-position: 0% 50%; transform: scale(1); box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.35);}
  25% { background-position: 50% 50%; transform: scale(1.03); box-shadow: 0px 6px 15px rgba(0, 0, 0, 0.35);}
	50% { background-position: 100% 50%; transform: scale(1); box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.35);}
  75% { background-position: 50% 50%; transform: scale(1.03); box-shadow: 0px 6px 15px rgba(0, 0, 0, 0.35);}
	100% { background-position: 0% 50%; transform: scale(1); box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.35);} 
`;

export const Button = styled.div`
	cursor: pointer;
	background: linear-gradient(
		78deg,
		#5ef28a 0.14%,
		#a7ffc1 33.3%,
		#a7ffc1 33.34%,
		#fbff27 66.57%,
		#fbff27 67.14%,
		#f2815e 97.57%
	);
	animation: ${gradient} 3s ease-in-out infinite;
	background-size: 400% 400%;
	border-radius: 5px;
	padding: 8px 20px;
	font-weight: 600;
	font-size: 16px;
	line-height: 24px;
	display: flex;
	align-items: center;
	letter-spacing: -0.5px;
	color: #43308e;
`;

export const Icon = styled.img`
	width: 21px;
	height: 21px;
`;
